var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReportNotStarted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51562 10.56V5.44003C6.51562 5.056 6.89965 4.80009 7.21965 4.99203L11.6357 7.55209C11.9556 7.74405 11.9556 8.19203 11.6357 8.38412L7.21965 10.9442C6.89968 11.1361 6.51562 10.8802 6.51562 10.4962V10.56Z",
    fill: "#2C5684"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C12.916 0 16.5 3.584 16.5 8C16.5 12.416 12.916 16 8.5 16C4.084 16 0.5 12.416 0.5 8C0.5 3.584 4.084 0 8.5 0ZM8.5 1.40803C4.852 1.40803 1.908 4.35203 1.908 8.00003C1.908 11.648 4.852 14.592 8.5 14.592C12.212 14.592 15.092 11.712 15.092 8.00003C15.092 4.35203 12.148 1.40803 8.5 1.40803Z",
    fill: "#2C5684"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportNotStarted);
export default __webpack_public_path__ + "static/media/icon-report-not-started.ff85b308f2f12cda751c90a5078a2ae3.svg";
export { ForwardRef as ReactComponent };